import { type LucideIcon } from "lucide-react";
import { type ReactNode } from "react";
import { FeedbackState } from "./FeedbackState";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  /** "dashed" = large bordered placeholder (page-level). "plain" = inline. */
  variant?: "dashed" | "plain";
  className?: string;
}

/**
 * Backward-compatible alias over {@link FeedbackState} (variant="empty").
 * Prefer FeedbackState directly for new code — it covers error / no-results /
 * forbidden / offline / success / warning too. This wrapper keeps existing
 * call sites working during migration.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = "dashed",
  className,
}: EmptyStateProps) {
  return (
    <FeedbackState
      variant="empty"
      icon={icon}
      title={title}
      description={description}
      primaryAction={action}
      surface={variant}
      className={className}
    />
  );
}
